<button
  [attr.aria-label]="!showLabel ? (!toggled ? setTogglePropertyLabel : unsetTogglePropertyLabel) : null"
  [class.grey-out-loading]="greyOutOnLoading && (loading || !initialized || toggled === undefined)"
  [class.loading]="!greyOutOnLoading && showLoadingIndicator && (loading || !initialized || toggled === undefined)"
  [class.toggled]="!!toggled"
  [class.toggling]="toggling"
  [class]="btnClass"
  [disabled]="disabled || (greyOutOnLoading && (loading || !initialized || toggled === undefined))"
  [ngbTooltip]="
    showTooltip && !isTouchDevice && !showLabel ? (!toggled ? setTogglePropertyLabel : unsetTogglePropertyLabel) : null
  "
  [openDelay]="!isTouchDevice ? 1000 : 0"
  (click)="onClick($event)"
  container="body"
>
  <ng-container *ngIf="toggled">
    <fa-icon *ngIf="showIcon" [class.me-0]="!showLabel" [icon]="togglePropertyIcon"></fa-icon>
    <span *ngIf="showLabel" class="label">
      {{ unsetTogglePropertyLabel }}
    </span>
    <span *ngIf="count !== undefined && count !== null && (count > 0 || showZeroCount)" class="count">
      {{ count | numberSuffix }}
    </span>
  </ng-container>

  <ng-container *ngIf="!toggled">
    <fa-icon *ngIf="showIcon" [class.me-0]="!showLabel" [icon]="togglePropertyIcon"></fa-icon>
    <span *ngIf="showLabel" class="label">
      {{ setTogglePropertyLabel }}
    </span>
    <span *ngIf="count !== undefined && count !== null && (count > 0 || showZeroCount)" class="count">
      {{ count | numberSuffix }}
    </span>
  </ng-container>
</button>
